import React from 'react';
import PropTypes from 'prop-types';

import { WHITE, GOLDEN_ROD } from '@constant/colors';

const Plus = ({ color, backgroundColor }) => (
  <svg className="transfer__option-plus" viewBox="0 1 32 13">
    <rect
      width="32"
      height="13"
      y="1"
      fill={backgroundColor}
      fillRule="evenodd"
      rx="6.5"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M8 10.232V4.598h2.424c1.343 0 2.088.762 2.088 1.86 0 1.113-.745 1.932-2.088 1.932H9.097v1.842H8zm2.326-4.75H9.097v2.023h1.229c.712 0 1.072-.434 1.072-1.032 0-.59-.36-.99-1.072-.99zm3.201 4.75V4.598h2.416c1.351 0 2.08.655 2.08 1.753 0 .802-.41 1.433-1.188 1.703l1.4 2.178H17.04l-1.294-2.047h-1.121v2.047h-1.098zm2.367-4.75h-1.27v1.843h1.27c.671 0 1.015-.41 1.015-.966 0-.54-.36-.876-1.015-.876zm2.866 1.933c0-1.679 1.13-2.915 2.874-2.915 1.711 0 2.866 1.236 2.866 2.915s-1.155 2.915-2.866 2.915c-1.744 0-2.874-1.236-2.874-2.915zm1.13 0c0 1.147.696 1.974 1.744 1.974 1.04 0 1.736-.836 1.736-1.974s-.696-1.973-1.736-1.973c-1.048 0-1.744.827-1.744 1.973z"
    />
  </svg>
);

Plus.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
};

Plus.defaultProps = {
  color: WHITE,
  backgroundColor: GOLDEN_ROD,
};

export default Plus;
